/**
 * Shared FCM token helpers (CRCN-832).
 *
 * The email lives under a role-specific key on the user object, so every
 * caller needs the same lookup. Kept in one place to stay in sync with the
 * logout flow in `store/auth/authSlice.ts`.
 */
export const resolveUserEmail = (user: any): string | undefined => {
  if (!user) return undefined;
  return (
    user.com?.email ??
    user.consultant?.email ??
    user.manager?.email ??
    user.employee?.email ??
    user.email
  );
};
